
import { config } from "./constant";
export const CALL_FORWARDED = "Your call has been forwarded to the voicemail for VMOBLE. No one is available to take your call. At the tone, please record your message. When you've finished recording, you may hang up or press the # key for more options.";
export const CALL_FORWARDED_AFTER_HOUR = "I'm sorry. No one is available to take your call. Thank you for calling. Goodbye!";
export const CALL_FORWARDED_BEFORE_HOUR = "Your call has been forwarded to the voicemail. No one is available to take your call. At the tone, please record your message. When you've finished recording, you may hang up or press the # key for more options.";
export const OPANING_HOURS_TEXT = "Thank you for calling VMOBLE. If you know the extension of the person you're calling, you can dial it at any time. For the Operator, please press 0. Thank you.";
export const CLOSING_HOURS_TEXT = "Thank you for calling VMOBLE. Sorry, we're closed now. Please call us later. Thank you. Goodbye!";
export const API_ROUTE_CONTROLLER = {
  currency: "£",
  /**************************** Start Dot Net Api *************************************/
  // Access Token
  //apiAccessToken: `${api_accesstoken}/Mobileapiinserttokenmaster`, // get token

  /**************************** End Dot Net Api *************************************/

  /**************************** Start Nodejs Api *************************************/
  //login
  basepath: `${config().BASEPATH}`,
  apiGetAddressApiKey: `${config().apiGetAddressApiKey}`,
  apiGetAddressURL: `${config().apiGetAddressURL}`,
  create_jwt: `${config().API_SERVICE_SSO_URL}/token/create_jwt`,
  hubspot_api: `${config().API_SERVICE_URL}/users/hubspot_api`,
  plan_sub_payment_fail: `${config().API_SERVICE_URL1}/plan_sub_payment_fail`,
  hubspot_assoisation: `${config().API_SERVICE_URL}/worktual/huspot_association_batch_create`,
  hubspot_api_new: `${config().API_SERVICE_URL}/users/hubspot_api_new`,
  refresh_jwt: `${config().API_SERVICE_SSO_URL}/token/refresh_jwt`,
  default_migration: `${config().API_SERVICE_REACT_URL}/default_migration`,
  update_detials: `${config().API_SERVICE_REACT_URL}/update_detials`,
  onboard_purchase: `${config().API_SERVICE_REACT_URL}/onboard_purchase`,
  purchase: `${config().API_SERVICE_REACT_URL}/purchase`,
  token: `${config().API_SERVICE_URL}/token/wk_create_token`,
  Urmyaccweblogin: `${config().API_SERVICE_URL}/login/Urmyaccweblogin`,
  web_token_login: `${config().API_SERVICE_URL}/login/web_token_login`,
  Urapploginforgotpwd: `${config().API_SERVICE_URL}/login/Urapploginforgotpwd`,
  // Urapploginforgotpwd: `https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/login/Urapploginforgotpwd`,
  PaymentAuthorization: "Basic OGFrMzdnSlVZcTJoUno6MGRpdWQ3NjVqZzk0YnNpODRqZmdqMHczamZoNzgyMmo=", // Dotnet payment api authorization
  update_myaccount_user: `${config().API_SERVICE_SSO_V2_URL}/administration/update_myaccount_user`,
  Urmyaccountgetcompanyaddress: `${config().API_SERVICE_URL}/worktual/get_company_address`,
  Urmyaccountinsertcompanyaddress: `${config().API_SERVICE_URL}/worktual/insert_company_address`,
  getUserDetailsByEmail: `${config().API_SERVICE_URL}/worktual/get_user_details_by_email`,

  //whatsapp
  whatsapp_intergration_insert: `${config().API_SERVICE_URL}/worktual/whatsapp_intergration_insert`,
  get_whatsapp_approve_status: `${config().API_SERVICE_URL}/worktual/get_whatsapp_approve_status`,
  ur_myaccount_get_whatsapp_integration: `${config().API_SERVICE_URL}/worktual/ur_myaccount_get_whatsapp_integration/`,

  //hubspot
  chatbot_free: `${config().API_SERVICE_URL1}/chatbot_free`,
  cancel_subscription: `${config().API_SERVICE_URL1}/cancel_subscription`,
  cancelSubscription: `${config().API_SERVICE_URL1}/cancelSubscription`,
  plan_activate_confirm: `${config().API_SERVICE_URL1}/plan_activate_confirm`,
  plan_activate_confirm_ccass: `${config().API_SERVICE_URL1}/plan_activate_confirm_ccass`,
  plan_activate_confirm_chatbot: `${config().API_SERVICE_URL1}/plan_activate_confirm_chatbot`,
  user_activation: `${config().API_SERVICE_URL1}/user_activation`,
  admin_activate: `${config().API_SERVICE_URL1}/admin_activate`,
  admin_deactivated: `${config().API_SERVICE_URL1}/admin_deactivated`,
  admin_cancel_user: `${config().API_SERVICE_URL1}/admin_cancel_user`,
  update_user_license: `${config().API_SERVICE_URL1}/update_user_license`,
  update_user_Details: `${config().API_SERVICE_URL1}/update_user_Details`,
  contract_cancel_monthly: `${config().API_SERVICE_URL1}/contract_cancel_monthly`,
  contract_cancel_final: `${config().API_SERVICE_URL1}/contract_cancel_final`,
  revoke_cancel: `${config().API_SERVICE_URL1}/revoke_cancel`,
  top_up_enable: `${config().API_SERVICE_URL1}/top_up_enable`,
  top_up_disable: `${config().API_SERVICE_URL1}/top_up_disable`,
  addon_cancel: `${config().API_SERVICE_URL1}/addon_cancel`,
  addon_cancel_undo: `${config().API_SERVICE_URL1}/addon_cancel_undo`,
  upgrade_payment_fail: `${config().API_SERVICE_URL1}/upgrade_payment_fail`,
  free_to_paid: `${config().API_SERVICE_URL1}/free_to_paid`,
  upgrade_payment_success: `${config().API_SERVICE_URL1}/upgrade_payment_success`,
  renew_payment_success: `${config().API_SERVICE_URL1}/renew_payment_success`,
  number_payment_success: `${config().API_SERVICE_URL}/number_payment_success`,
  number_payment_fail: `${config().API_SERVICE_URL}/number_payment_fail`,
  device_payment_success: `${config().API_SERVICE_URL}/device_payment_success`,
  device_payment_fail: `${config().API_SERVICE_URL}/device_payment_fail`,

  // Dashboard
  Urbillgetserviceplan: `${config().API_SERVICE_URL}/dashboard/Urbillgetserviceplan`,
  Urautorenewalenableanddisable: `${config().API_SERVICE_URL}/company/worktual_auto_renewal_enable_disable`,
  Urgetautorenewalstatus: `${config().API_SERVICE_URL}/company/worktual_get_auto_renewal_status`,


  recordingTranslation: `${config().API_SERVICE_URL}/transcription/getTranscriptSettings/`,
  video_audio_Translation: `${config().API_SERVICE_URL}/translation/getAddOnVideoAudioSettings/`,

  // resend invitation
  Urmyaccountgetonboardinglink: `${config().API_SERVICE_URL}/onboard/Urmyaccountgetonboardinglink`,
  // cancel invitation
  docancelinivitation: `${config().API_SERVICE_URL}/worktual/docancelinivitation`,
  getbulkonboardinglink: `${config().API_SERVICE_URL}/worktual/getbulkonboardinglink`,
  getdeleteuser: `${config().API_SERVICE_URL}/worktual/getdeleteuser`,
  restoreuser: `${config().API_SERVICE_URL}/worktual/restore_user`,
  editivrkeydtl: `${config().API_SERVICE_URL}/worktual/edit_ivr_key_dtl`,
  createsyncupaccountdetails: `${config().API_SERVICE_URL}/worktual/create_sync_up_account_details`,
  getsyncupaccountdetails: `${config().API_SERVICE_URL}/worktual/get_sync_up_account_details`,
  cancelAddonInfo: `${config().API_SERVICE_URL}/worktual/cancel_addon_info`,

  //Company
  Urmyaccwebgetcompanyworkinghours: `${config().API_SERVICE_URL}/company/Urmyaccwebgetcompanyworkinghours`,
  Urmyaccwebinsertcompanyworkinghourscompany: `${config().API_SERVICE_URL}/company/Urmyaccwebinsertcompanyworkinghours`,
  Get_admin_list: `${config().API_SERVICE_REACT_URL}/get_admin_list`,
  Urmyaccountholidayannouncementgetdetails: `${config().API_SERVICE_URL}/company/Urmyaccountholidayannouncementgetdetails`,
  Urmyaccwebuserorderextension: `${config().API_SERVICE_URL}/company/Urmyaccwebuserorderextension`,
  get_master_dept_list: `${config().API_SERVICE_URL}/worktual/get_master_dept_list`,
  insertUpdate_UserDeptContact: `${config().API_SERVICE_URL}/worktual/insertUpdate_UserDeptContact`,
  get_User_Dept_Contact: `${config().API_SERVICE_URL}/worktual/get_User_Dept_Contact`,
  

  Urmyaccwebgetcompanydtlcompany: `${config().API_SERVICE_URL}/company/Urmyaccwebgetcompanydtl`,
  Urmyaccwebupdatecompanydtl: `${config().API_SERVICE_URL}/company/Urmyaccwebupdatecompanydtl`,
  Urmyaccountholidayannouncementcreate: `${config().API_SERVICE_URL}/company/Urmyaccountholidayannouncementcreate`,
  Urmyaccwebupdatecompanyregionalsetting: `${config().API_SERVICE_URL}/company/Urmyaccwebupdatecompanyregionalsetting`,
  Urmyaccwebgetaudiofile: `${config().API_SERVICE_URL}/company/Urmyaccwebgetaudiofile`,
  deleteuserinfo: `${config().API_SERVICE_URL}/worktual/deleteuserinfo`,
  licenseinfo: `${config().API_SERVICE_URL}/worktual/licenseinfo`,

  getmanagecolumndetails: `${config().API_SERVICE_URL}/worktual/getmanagecolumndetails`,
  get_defalut_manage_column_details: `${config().API_SERVICE_URL}/worktual/get_defalut_manage_column_details`,

  savemanagecolumndtl: `${config().API_SERVICE_URL}/worktual/savemanagecolumndtl`,
  update_billing_admin: `${config().API_SERVICE_URL}/worktual/update_billing_admin`,
  get_users_by_role: `${config().API_SERVICE_URL}/worktual/get_users_by_role`,
  huntgroup_routeto_update: `${config().API_SERVICE_URL}/worktual/huntgroup_routeto_update`,
  get_hunt_group_greeting: `${config().API_SERVICE_URL}/worktual/get_hunt_group_greeting`,

  Urmyaccwebinsertaudiofileonboard: `${config().API_SERVICE_URL}/onboard/Urmyaccwebinsertaudiofile`,

  insert_hunt_group_greeting: `${config().API_SERVICE_URL}/worktual/insert_hunt_group_greeting`,

  Get_callLog_list: `https://stagemysql-api.worktual.co.uk/urcall/v1/cdr/get_logs`,
  //Excel_export_calllog: `https://stagemysql-api.worktual.co.uk/urcall/v1/cdr/download?limit=10&offset=1&fromDate=2022-04-20&toDate=2022-12-08&domainName=8032.urcall.worktual.co.uk`,
  Get_voicemail_list: `https://stagemysql-api.worktual.co.uk/urcall/v1/voicemail/filters`,
  delete_log: `https://stagemysql-api.worktual.co.uk/urcall/v1/cdr/delete_logs`,

  Urmyaccwebgetivrsetting: `${config().API_SERVICE_URL}/company/Urmyaccwebgetivrsetting`,
  get_product_details: `${config().API_SERVICE_URL}/worktual/get_product_details`,
  getroleinfo: `${config().API_SERVICE_URL}/worktual/getroleinfo`,
  Urmyaccountgetdidnocountrycity: `${config().API_SERVICE_URL}/company/Urmyaccountgetdidnocountrycity`,
  validateOwner: `${config().API_SERVICE_URL}/worktual/validate_password_by_change_owner`,
  getSubOwner: `${config().API_SERVICE_URL}/worktual/get_subowner_list_by_changing_owner`,
  changeAccountOwner: `${config().API_SERVICE_URL}/worktual/update_owner_by_changing_owner`,
  ur_ma_get_secondary_plan: `${config().API_SERVICE_URL}/worktual/ur_ma_get_secondary_plan`,
  wtms_bill_get_service_plan_exclude_sec_plan: `${config().API_SERVICE_URL}/worktual/wtms_bill_get_service_plan_exclude_sec_plan`,

  enterSocialAccount: `${config().API_SERVICE_URL}/login/social_account_login`,


  //Settings
  Urmyaccwebgetcallrecordingdtl: `${config().API_SERVICE_URL}/settings/Urmyaccwebgetcallrecordingdtl`,

  //Role
  createrolemaster: `${config().API_SERVICE_URL}/worktual/createrolemaster`,
  get_organisation_role: `${config().API_SERVICE_URL}/worktual/get_organisation_role`,
  getproductbycompany: `${config().API_SERVICE_URL}/worktual/getproductbycompany`,
  getfeaturelistbycompanyproduct: `${config().API_SERVICE_URL}/worktual/getfeaturelistbycompanyproduct`,
  updaterolepermission: `${config().API_SERVICE_URL}/worktual/updaterolepermission`,
  insertProductrole: `${config().API_SERVICE_URL}/worktual/bulkuserupdaterole`,
  get_role_permission: `${config().API_SERVICE_URL}/worktual/get_role_permission`,
  get_addon_list: `${config().API_SERVICE_URL}/worktual/get_addon_list`,

  //smart assist
  ur_myaccount_manage_smart_assistant_info: `${config().API_SERVICE_URL}/call/ur_myaccount_manage_smart_assistant_info`,
  ur_myaccount_get_smart_assistant_info: `${config().API_SERVICE_URL}/call/ur_myaccount_get_smart_assistant_info`,

  //Purchase 
  Urgetaddonfeaturelist: `${config().API_SERVICE_URL}/billing/Urgetaddonfeaturelist`,
  bulk_addon_purchase: `${config().API_SERVICE_URL}/worktual/bulk_addon_purchase`,
  addon_user_creation: `${config().API_SERVICE_URL}/worktual/addon_user_creation`,
  ur_get_all_active_plan_by_company_id: `${config().API_SERVICE_URL}/worktual/ur_get_all_active_plan_by_company_id`,
  new_prod_purchaseApi: `${config().API_SERVICE_URL}/call/secondary_plan_purchase_request`,
  insert_secondary_plan_change_request: `${config().API_SERVICE_URL}/worktual/insert_secondary_plan_change_request`,

//Shopify
ur_myacc_shopify_plan_change_request: `${config().API_SERVICE_URL}/worktual/ur_myacc_shopify_plan_change_request`,
get_shopify_plan_change: `${config().API_SERVICE_URL}/worktual/get_shopify_plan_change/`,



  getTranslationSettings: `${config().API_SERVICE_URL}/translation/getTranslationSettings`,
  getAddOnVideoAudioSettings: `${config().API_SERVICE_URL}/translation/getAddOnVideoAudioSettings`,

  // Phone Numbers
  Urassignphonegetnumberdtl: `${config().API_SERVICE_URL}/numbers_devices/Urassignphonegetnumberdtl`,
  Urmyaccountcompwisecountrydrp: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccountcompwisecountrydrp`,
  Urphonenumberassigntypeget: `${config().API_SERVICE_URL}/numbers_devices/Urphonenumberassigntypeget`,
  URmaassignunassignphoneaddnumberdtl: `${config().API_SERVICE_URL}/numbers_devices/URmaassignunassignphoneaddnumberdtl`,
  Urphonegetnumbertype: `${config().API_SERVICE_URL}/numbers_devices/Urphonegetnumbertype`,
  Urmaphoneaddnumbergetnumberdtl: `${config().API_SERVICE_URL}/numbers_devices/Urmaphoneaddnumbergetnumberdtl`,
  Urmyaccountgetavaialblemsisdn: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccountgetavaialblemsisdn`,
  Urgetmyaccuserlocation: `${config().API_SERVICE_URL}/numbers_devices/Urgetmyaccuserlocation`,
  Urmaphonenumbergetcity: `${config().API_SERVICE_URL}/numbers_devices/Urmaphonenumbergetcity`,
  Getlandlinenumberlist: `${config().API_SERVICE_URL}/numbers_devices/Getlandlinenumberlist`,
  myaccountDoPortinRequest: `${config().API_SERVICE_URL}/numbers_devices/myaccountDoPortinRequest`,
  user_assign_unassign_count: `${config().API_SERVICE_URL}/worktual/user_assign_unassign_count`,


  // adminonboarding
  Urecomonboardgetadmindetailsinfo: `${config().API_SERVICE_URL}/onboard/Urecomonboardgetadmindetailsinfo`,
  Urecomvalidateuserextensionstatus: `${config().API_SERVICE_URL}/onboard/Urecomvalidateuserextensionstatus`,
  Urmyaccountgetmainnumber: `${config().API_SERVICE_URL}/onboard/Urmyaccountgetmainnumber`,
  Urmyaccountgetpersonalinfo: `${config().API_SERVICE_URL}/onboard/Urmyaccountgetpersonalinfo`,
  Urmyaccwebgetcompanydtlonboard: `${config().API_SERVICE_URL}/onboard/Urmyaccwebgetcompanydtl`,
  Urecominsertuserextensiondtl: `${config().API_SERVICE_URL}/onboard/Urecominsertuserextensiondtl`,
  aiccaasonboardingdtl:`${config().API_SERVICE_URL}/onboard/aiccaas_insert_onboard_user`,
  crmonboardingdtl:`${config().API_SERVICE_URL}/onboard/crm_insert_onboard_user`,
  newproductaccessdtl:`${config().API_SERVICE_URL}/onboard/ur_insert_update_product_access`,
  Urmyaccwebinsertcompanyworkinghoursonboard: `${config().API_SERVICE_URL}/onboard/Urmyaccwebinsertcompanyworkinghours`,
  Urmyaccwebinsertaudiofilecompany: `${config().API_SERVICE_URL}/company/Urmyaccwebinsertaudiofile`,
  Urmaivroperatorextensionupdate: `${config().API_SERVICE_URL}/onboard/Urmaivroperatorextensionupdate`,
  Urmadialbydirupdatedtl: `${config().API_SERVICE_URL}/onboard/Urmadialbydirupdatedtl`,
  Urmyaccwebupdatecallrecording: `${config().API_SERVICE_URL}/onboard/Urmyaccwebupdatecallrecording`,
  Urmyaccwebivrinsertextentionaudiofile: `${config().API_SERVICE_URL}/onboard/Urmyaccwebivrinsertextentionaudiofile`,
  Urextncallrecordinsertsetting: `${config().API_SERVICE_URL}/onboard/Urextncallrecordinsertsetting`,
  Urmyaccwebvoicemsgninsertextentionaudiofile: `${config().API_SERVICE_URL}/onboard/Urmyaccwebvoicemsgninsertextentionaudiofile`,
  Urextnvoicemailinsertsetting: `${config().API_SERVICE_URL}/onboard/Urextnvoicemailinsertsetting`,
  Urmyaccwebinsertcallhandlingforwarding: `${config().API_SERVICE_URL}/onboard/Urmyaccwebinsertcallhandlingforwarding`,
  Uraddemailalertsnotifications: `${config().API_SERVICE_URL}/onboard/Uraddemailalertsnotifications`,
  Urmyaccountinsertemailnotif: `${config().API_SERVICE_URL}/onboard/Urmyaccountinsertemailnotif`,
  Urmyaccwebupdateextensionloginpassword: `${config().API_SERVICE_URL}/onboard/Urmyaccwebupdateextensionloginpassword`,
  Urmyaccwebupdateuserextensiondtl: `${config().API_SERVICE_URL}/onboard/Urmyaccwebupdateuserextensiondtl`,
  Urmyaccwebuserextesiondelete: `${config().API_SERVICE_URL}/onboard/Urmyaccwebuserextesiondelete`,
  UserDeleteRestore: `${config().API_SERVICE_URL}/worktual/bulkuserdelete`,

  Urmyaccemergcontactsave: `${config().API_SERVICE_URL}/onboard/Urmyaccemergcontactsave`,
  Uronboardinsertuserdetails: `${config().API_SERVICE_URL}/onboard/Uronboardinsertuserdetails`,
  Urwebmultiivrfeaturegetivrcount: `${config().API_SERVICE_URL}/onboard/Urwebmultiivrfeaturegetivrcount`,
  Urmabulkupdatehubspotcontact: `${config().API_SERVICE_URL}/onboard/Urmabulkupdatehubspotcontact`,
  Urmyaccountupdateonboardinglink: `${config().API_SERVICE_URL}/onboard/Urmyaccountupdateonboardinglink`,
  worktualOnboardDefalutCreationDetails: `${config().API_SERVICE_URL}/onboard/worktualOnboardDefalutCreationDetails`,
  upadateurmobile: `${config().API_SERVICE_URL}/users/upadateurmobile`,
  insertmobilenumbertypeinfo: `${config().API_SERVICE_URL}/users/insertmobilenumbertypeinfo`,
  Urmyaccountusermgtgetmodule: `${config().API_SERVICE_URL}/users/Urmyaccountusermgtgetmodule`,
  Urmyacccountgethuntgroupmembers: `${config().API_SERVICE_URL}/users/Urmyacccountgethuntgroupmembers`,

  Urmabulkuploaduserextension: `${config().API_SERVICE_URL}/billing/Urmabulkuploaduserextension`,
  ecomPaymentAccountVerification: `${config().API_SERVICE_ECOMPAY_URL}/ecommpay/accountVerification`,
  hubspot_associations: `${config().API_SERVICE_URL}/users/hubspot_associations`,

  ccaasMailBoxCreate: `${config().apiNodeURL}/token/ccass_domain_mailbox`,
  ccaasDomainCreateInfo: `${config().apiNodeURL}/token/domain_create_info`,
  create_email_config: `${config().apiCcaasEmailURL}/onbord_create_email`,
  createEmailconfigDetails: `${config().MARKETING_SERVICE}/common/CRM_create_email_config_details`,
  insertOnboardCrmUser: `${config().MARKETING_SERVICE}/common/insert_onboard_user`,
 


  //the Hubspot Properties for Worktual Admin Cancel the User Invite Link Scenario

  hubspot_properties: `${config().API_SERVICE_URL}/worktual/get_hubspot_mail_status`,
  dashboard_count: `${config().API_SERVICE_URL}/worktual/dashboardCount`,



  // user onboarding
  Uronboardgetuserdetails: `${config().API_SERVICE_URL}/onboard/Uronboardgetuserdetails`,
  UrMyaccountBulkUserInsertSendOnboardLink: `${config().API_SERVICE_URL}/onboard/UrMyaccountBulkUserInsertSendOnboardLink`,
  //did number purchase 
  getCountryList: `${config().didNumPurchaseURL}/did/v1/getCountries`,
  getGroupType: `${config().didNumPurchaseURL}/did/v1/getGroupType`,
  getCityList: `${config().didNumPurchaseURL}/did/v1/getCities`,
  getDidList: `${config().didNumPurchaseURL}/did/v1/getAvailableDids?cityId=`,
  getDocumentReq: `${config().didNumPurchaseURL}/did/v1/getRequirements`,
  getskuId: `${config().didNumPurchaseURL}/did/v1/getSkuId`,
  getCreateId: `${config().didNumPurchaseURL}/did/v1/createIdentity`,
  getOrderPurchase: `${config().didNumPurchaseURL}/did/v1/order`,
  encryptedFile: `${config().didNumPurchaseURL}/did/v1/encryptFiles`,
  verifyApi: `${config().didNumPurchaseURL}/did/v1/verify`,
  proofTypesApi: `${config().didNumPurchaseURL}/did/v1/proofTypes`,
  get_country_by_iso: `${config().API_SERVICE_URL}/numbers_devices/get_country_by_iso3`,
  getoperator: `${config().API_SERVICE_URL}/numbers_devices/getoperator`,
  didnumber_upload_integration: `${config().API_SERVICE_URL}/numbers_devices/didnumber_upload_integration`,

  // docusign
  

  //number and devices
  Urmaphonenumbergetcountry: `${config().API_SERVICE_URL}/numbers_devices/Urmaphonenumbergetcountry`,
  Urdevicegetstockorder: `${config().API_SERVICE_URL}/numbers_devices/Urdevicegetstockorder`,
  Urdevicegetstockorderdtl: `${config().API_SERVICE_URL}/numbers_devices/Urdevicegetstockorderdtl`,
  Urmyaccemergcontactget: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccemergcontactget`,
  Urmyaccaddphonegetdirectnumber: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccaddphonegetdirectnumber`,
  Urgetproductlistforweborder: `${config().API_SERVICE_URL}/numbers_devices/Urgetproductlistforweborder`,
  Urmyaccountgetdevicebrandtype: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccountgetdevicebrandtype`,
  Urshippingcarrierget: `${config().API_SERVICE_URL}/numbers_devices/Urshippingcarrierget`,
  Urmyaccountgetemailnotif: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccountgetemailnotif`,
  Urgetemailalertsnotifications: `${config().API_SERVICE_URL}/numbers_devices/Urgetemailalertsnotifications`,
  //Urdeviceinsertstockorder: `${config().API_SERVICE_URL}/numbers_devices/Urdeviceinsertstockorder`,
  Urdeviceinsertstockorder: `${config().API_SERVICE_URL}/worktual/insert_stock_order_multixml`,
  Urmainsertphoneaddnumber: `${config().API_SERVICE_URL}/numbers_devices/Urmainsertphoneaddnumber`,
  Urmyaccgetportinrequest: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccgetportinrequest`,
  Urmaphoneupdatemacaddress: `${config().API_SERVICE_URL}/company/Urmaphoneupdatemacaddress`,
  Urmaupdateprovisionfiledtl: `${config().API_SERVICE_URL}/company/Urmaupdateprovisionfiledtl`,
  Urdeviceorderreturninsert: `${config().API_SERVICE_URL}/numbers_devices/Urdeviceorderreturninsert`,
  Urdeviceorderreplacementinsert: `${config().API_SERVICE_URL}/numbers_devices/Urdeviceorderreplacementinsert`,
  Urmyaccountgetinvoiceidbyorderreference: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccountgetinvoiceidbyorderreference`,
  Urmyaccountcreateinvoicedetail: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccountcreateinvoicedetail`,
  get_purchased_device_info: `${config().API_SERVICE_URL}/worktual/get_purchased_device_info/`,
  reassign_device: `${config().API_SERVICE_URL}/worktual/reassign_device`,
  replace_device_details: `${config().API_SERVICE_URL}/worktual/replace_device_details`,

  //SIP Trunk
  get_up_Insert_Update_SIPTrunk: `${config().API_SERVICE_URL}/worktual/get_up_Insert_Update_SIPTrunk`, // add & update Sip Trunk
  up_getsiptrunklist: `${config().API_SERVICE_URL}/worktual/up_getsiptrunklist`, // sip trunk list
  get_up_getSipTrunkById: `${config().API_SERVICE_URL}/worktual/get_up_getSipTrunkById`, // trunk get by ID
  get_ur_myacc_get_dc_ip: `${config().API_SERVICE_URL}/worktual/get_ur_myacc_get_dc_ip`, //IP get based on CompanyID
  worktual_create_ipdomain_whitelist: `${config().API_SERVICE_URL}/worktual/worktual_create_ipdomain_whitelist`, // ip insert (UMN)
  whitelistupdation: `${config().API_SERVICE_URL}/worktual/whitelistupdation`,  // Redis for add
  sip_trunk_num_check: `${config().CCAAS_SERVICE_URL}/sip_trunk_num_check`, // ccaas number check
  sip_trunk_num_delete: `${config().CCAAS_SERVICE_URL}/sip_trunk_num_delete`, // ccaas did number delete
  onboard_delete_user: `${config().CCAAS_SERVICE_URL}/onboard_delete_user`, // ccaas did number delete
  deleteSIPTrunk: `${config().API_SERVICE_URL}/worktual/deleteSIPTrunk`,  // Delete sip trunk
  getIP_connectivity_info: `${config().API_SERVICE_URL}/worktual/getIP_connectivity_info`,  // IP Connectivity Status


  // users - call forwarding and handling
  Urmyaccwebgetcallsringtype: `${config().API_SERVICE_URL}/users/Urmyaccwebgetcallsringtype`,
  Urmyaccwebgetcallsforwardtype: `${config().API_SERVICE_URL}/users/Urmyaccwebgetcallsforwardtype`,
  Urmyaccwebgetcallhandlingforwarding: `${config().API_SERVICE_URL}/users/Urmyaccwebgetcallhandlingforwarding`,
  Urmyaccwebgetmobilenumbertypeinfo: `${config().API_SERVICE_URL}/users/Urmyaccwebgetmobilenumbertypeinfo`,
  Urmyaccmobilenumbertypeinfo: `${config().API_SERVICE_URL}/users/Urmyaccmobilenumbertypeinfo`,
  Urmyaccountuniqueextensionvalidation: `${config().API_SERVICE_URL}/users/Urmyaccountuniqueextensionvalidation`,

  // NFS
  save: `${config().NFS_URL}/save`,
  // text_to_speech: `${config().SPEECH_URL}/texttospeech/text_to_speech`,
  text_to_speech: `https://readspeaker.worktual.co.uk/rest/vtspeech?voice=Alice&lang=en_uk&&pitch=110&speed=96&srate=16000&aformat=wav&text=`,
  upload: `${config().NFS_URL}/upload`,

  //billing
  Urmyaccountgetcccardinfo: `${config().API_SERVICE_URL}/billing/Urmyaccountgetcccardinfo`,
  Urbillgetdirectdebitaccount: `${config().API_SERVICE_URL}/billing/Urbillgetdirectdebitaccount`,
  Urmyaccountgetsubscribedaddonbundle: `${config().API_SERVICE_URL}/billing/Urmyaccountgetsubscribedaddonbundle`,
  Urmyaccgetwebratescountrysummaryinfo: `${config().API_SERVICE_URL}/rate/urMyaccgetwebratescountrysummaryinfo`,
  Urmyaccgetwebratescountryprefixinfo: `${config().API_SERVICE_URL}/rate/urMyaccgetwebratescountryprefixinfo`,
  Urbillgetcustomerinvoicesummary: `${config().API_SERVICE_URL}/billing/Urbillgetcustomerinvoicesummary`,
  // Urbillgetcustomerinvoicesummary: `https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/billing/Urbillgetcustomerinvoicesummary`,
  getTirePlanPurposeInfo: `${config().API_SERVICE_URL_UTMS}/user/getTirePlanPurposeInfo`,
  worktualgetfeaturedetailsinfo: `${config().API_SERVICE_URL_UTMS}/product/worktualgetfeaturedetailsinfo`,
  Urmyaccountviewinvoicebreakup: `${config().API_SERVICE_URL}/billing/Urmyaccountviewinvoicebreakup`,
  cancelContractGetPlanInfo: `${config().API_SERVICE_URL}/billing/cancelContractGetPlanInfo/`,
  doCancelRequest: `${config().API_SERVICE_URL}/billing/doCancelRequest`,
  accunDoCancelContractRequest: `${config().API_SERVICE_URL}/billing/accunDoCancelContractRequest/`,
  Urdevicegetusertype: `${config().API_SERVICE_URL}/billing/Urdevicegetusertype`,
  Urmyaccounttopupgetdenominationlist: `${config().API_SERVICE_URL}/billing/Urmyaccounttopupgetdenominationlist`,
  checkDefaultCardType: `${config().API_SERVICE_URL}/billing/checkDefaultCardType`,
  // Urplanupgradegetpriceinfo: `${config().API_SERVICE_URL}/billing/Urplanupgradegetpriceinfo`,
  Urmyaccountcreateupdatedirectdebitinfo: `${config().API_SERVICE_URL}/billing/Urmyaccountcreateupdatedirectdebitinfo`,
  Urmyaccountgetaddonfeaturelist: `${config().API_SERVICE_URL}/billing/Urmyaccountgetaddonfeaturelist`,
  // createSubscription: `${config().MYACCOUNT_CARD_URL}/ecommerce/createSubscription`,
  Urmyaccwebgetcompanydtl: `${config().API_SERVICE_URL}/company/Urmyaccwebgetcompanydtl`,
  URportalgetnewplaninfo: `${config().API_SERVICE_URL}/billing/URportalgetnewplaninfo`,
  Urplanupgradegetpriceinfo: `${config().API_SERVICE_URL}/billing/getNewPlanInfo`,
  UrgetBillServicePlan: `${config().API_SERVICE_URL}/billing/getBillServicePlan`,
  Urbundleconfigget: `${config().API_SERVICE_URL}/billing/Urbundleconfigget`,
  Uradditionalbundlesubscribeget: `${config().API_SERVICE_URL}/billing/Uradditionalbundlesubscribeget`,
  UraccountCheckPlanUpgrade: `${config().API_SERVICE_URL}/billing/wtmsMyaccountCheckPlanUpgrade`,
  UrgetSummaryInfo: `${config().API_SERVICE_URL}/billing/getSummaryInfo`,
  pricinggetlocationdetail: `${config().API_PRICING_URL}/get_location_details`,
  getSavedCardList: `${config().ECOM_PAYMENT_URL}/getAccountDeatils`,
  billingAddress: `${config().API_PRICING_URL}/user_insert_biiling_addres`,
  savedCard: `${config().ECOM_PAYMENT_URL}/savedCard`,

  //Recording
  Urmyaccrulegetautocallrecord: `${config().API_SERVICE_URL}/call/Urmyaccrulegetautocallrecord`,
  Urmyaccruleenableautocallrecord: `${config().API_SERVICE_URL}/call/Urmyaccruleenableautocallrecord`,
  Urmyaccruleupdateautocallrecord: `${config().API_SERVICE_URL}/call/Urmyaccruleupdateautocallrecord`,

  // Addon
  getAddonListByPlan: `${config().API_SERVICE_URL}/addon/getAddonListByPlan`,
  companySaveAddonInfo: `${config().API_SERVICE_URL}/addon/companySaveAddonInfo`,
  getAddedAddonList: `${config().API_SERVICE_URL}/addon/getAddedAddonList`,
  getUserExtension: `${config().API_SERVICE_URL}/addon/getUserExtension`,
  assignAddonExtension: `${config().API_SERVICE_URL}/addon/assignAddonExtension`,
  getAddonFeatureList: `${config().API_SERVICE_URL}/addon/getAddonFeatureList`,
  doAddonPurchase: `${config().API_SERVICE_URL}/addon/doAddonPurchase`,
  getPurchasedAddonInfo: `${config().API_SERVICE_URL}/addon/getPurchasedAddonInfo/`,
  Urmyaccountaddonbundlepurchase: `${config().API_SERVICE_URL}/addon/Urmyaccountaddonbundlepurchase`,
  Urmyaccountdoaddonpurchase: `${config().API_SERVICE_URL}/addon/Urmyaccountdoaddonpurchase`,
  get_all_addon_list: `${config().API_SERVICE_URL}/worktual/get_all_addon_list`,
  insertCcaasAddOnList: `${config().callServices}/onboard_company_purchase_addon`,

  worktualGetProdWiseAddonList: `${config().API_SERVICE_URL_UTMS}/product/worktualGetProdWiseAddonList`,
  getProductwiseCategoryidNameList: `${config().API_SERVICE_URL_UTMS}/product/getProductwiseCategoryidNameList`,

  //huntgroup
  Urmyacccountgethuntgroupdtl: `${config().API_SERVICE_URL}/call/Urmyacccountgethuntgroupdtl`,
  Urmyaccountcheckfeatureinfo: `${config().API_SERVICE_URL}/call/Urmyaccountcheckfeatureinfo`,
  //Urmyaccountcallqueuegetcustomhour: `${config().API_SERVICE_URL}/call/Urmyaccountcallqueuegetcustomhour`,
  Urmyaccounthuntgroupgetcustomhour: `${config().API_SERVICE_URL}/call/Urmyaccounthuntgroupgetcustomhour`,
  Urmyaccwebivrgetmusictype: `${config().API_SERVICE_URL}/call/Urmyaccwebivrgetmusictype`,
  Urmyaccountedithuntgroup: `${config().API_SERVICE_URL}/call/Urmyaccountedithuntgroup`,
  Urmyaccountbulkenabledelete: `${config().API_SERVICE_URL}/call/Urmyaccountbulkenabledelete`,
  Urextncallrecordgetsetting: `${config().API_SERVICE_URL}/call/Urextncallrecordgetsetting`,
  GetlandlinenumberlistV2: `${config().API_SERVICE_URL}/users/GetlandlinenumberlistV2`,

  //annoucement
  Urmaannouncementgetextension: `${config().API_SERVICE_URL}/call/Urmaannouncementgetextension`,
  Urmaannouncementinsertextension: `${config().API_SERVICE_URL}/call/Urmaannouncementinsertextension`,
  Urmaannouncementupdateextension: `${config().API_SERVICE_URL}/call/Urmaannouncementupdateextension`,
  Urmaparklocationdelete: `${config().API_SERVICE_URL}/call/Urmaparklocationdelete`,

  //parklocation
  Urparklocationgetgroupmembers: `${config().API_SERVICE_URL}/call/Urparklocationgetgroupmembers`,
  Urparklocationinsertgroup: `${config().API_SERVICE_URL}/call/Urparklocationinsertgroup`,
  Urgetcompanyextensiondtl: `${config().API_SERVICE_URL}/call/Urgetcompanyextensiondtl`,
  Urparklocationupdategroupmembers: `${config().API_SERVICE_URL}/call/Urparklocationupdategroupmembers`,
  Urparklocationdelete: `${config().API_SERVICE_URL}/call/Urparklocationdelete`,
  myaccountGetSavedCard: `${config().API_SERVICE_URL}/call/myaccountGetSavedCard/`,
  myaccountGetDirectDebitInfo: `${config().API_SERVICE_URL}/call/myaccountGetDirectDebitInfo/`,

  //payment
  // paymentStep1: `${config().PAYMENT_URL}/CTACCTopupStep1`,
  // paymentStep2: `${config().PAYMENT_URL}/CTACCTopupStep2`,
  UrappRxSavedCardPayment: `${config().API_SERVICE_URL}/transaction/UrappRxSavedCardPayment`,

  //3ds

  threeDSFormLocalhost: `${config().API_SERVICE_URL_LIVE}/threeds/threedsformLocalhost`,
  threeDSForm: `${config().API_SERVICE_URL_LIVE}/threeds/threedsform`,
  get_threeds_form_data: `${config().API_SERVICE_URL_LIVE}/threeds/get_threeds_form_data`,
  delete_threeds_form_data: `${config().API_SERVICE_URL_LIVE}/threeds/delete_threeds_form_data`,
  delete_saved_card: `${config().API_SERVICE_URL}/billing/Urmyaccountdeletecarddirectdebitaccount`,

  //user
  Urecomcreatebulkuserextensions: `${config().API_SERVICE_URL}/users/Urecomcreatebulkuserextensions`,
  Urmyaccountusermgtgetrole: `${config().API_SERVICE_URL}/users/Urmyaccountusermgtgetrole`,
  Urmainsertplanchangerequest: `${config().API_SERVICE_URL}/users/Urmainsertplanchangerequest`,
  Urgetmultivrcount: `${config().API_SERVICE_URL}/billing/Urgetmultivrcount`,
  Urmyaccwebuserextesiondeleteuser: `${config().API_SERVICE_URL}/users/Urmyaccwebuserextesiondelete`,
  Urmyaccountusermgtcreaterole: `${config().API_SERVICE_URL}/users/Urmyaccountusermgtcreaterole`,
  Urmyaccwebgetuserextensioninfo: `${config().API_SERVICE_URL}/users/Urmyaccwebgetuserextensioninfo`,
  Urmyaccwebvoicemsgngetextentionaudiofile: `${config().API_SERVICE_URL}/users/Urmyaccwebvoicemsgngetextentionaudiofile`,
  Uruserextngetblocknumber: `${config().API_SERVICE_URL}/users/Uruserextngetblocknumber`,
  Urgetnocalleridextnblocknumber: `${config().API_SERVICE_URL}/users/Urgetnocalleridextnblocknumber`,
  Urupdatenocalleridextnblocknumber: `${config().API_SERVICE_URL}/users/Urupdatenocalleridextnblocknumber`,
  Uruserextninsertblocknumber: `${config().API_SERVICE_URL}/users/Uruserextninsertblocknumber`,
  Urmyaccountassignlicenceusertoexistingextn: `${config().API_SERVICE_URL}/users/Urmyaccountassignlicenceusertoexistingextn`,
  Urmyaccwebivrgetextentionaudiofile: `${config().API_SERVICE_URL}/users/Urmyaccwebivrgetextentionaudiofile`,
  Urextnvoicemailgetsetting: `${config().API_SERVICE_URL}/users/Urextnvoicemailgetsetting`,
  Urmyaccgetsendvoicemailtoemail: `${config().API_SERVICE_URL}/users/Urmyaccgetsendvoicemailtoemail`,
  Urgetbulkuploadtemplate: `${config().API_SERVICE_URL}/users/Urgetbulkuploadtemplate`,
  Urmyaccountconvertuserliscencetype: `${config().API_SERVICE_URL}/users/Urmyaccountconvertuserliscencetype`,
  onboard_temporary_delete_user: `${config().CCAAS_SERVICE_URL}/onboard_temporary_delete_user`,


  //callqueue
  //Urmyaccountcallqueuebulkenabledelete: `${config().API_SERVICE_URL}/call/Urmyaccountcallqueuebulkenabledelete`,
  //Urmyaccountcallqvoicemailstatusupdate: `${config().API_SERVICE_URL}/call/Urmyaccountcallqvoicemailstatusupdate`,
  //Urmyaccountcallqsharevoicemailtouser: `${config().API_SERVICE_URL}/call/Urmyaccountcallqsharevoicemailtouser`,
  //Urmyaccountcallqrecordingstatusupdate: `${config().API_SERVICE_URL}/call/Urmyaccountcallqrecordingstatusupdate`,
  //Urmyacccountcheckcallqueuename: `${config().API_SERVICE_URL}/call/Urmyacccountcheckcallqueuename`, --not using
  getCallQueueMembers: `${config().API_SERVICE_URL}/call/getCallQueueMembers`,
  Urmyacccountgetcallqueuedetails: `${config().API_SERVICE_URL}/call/Urmyacccountgetcallqueuedetails`,
  Urmyaaccounteditcallqueuedetails: `${config().API_SERVICE_URL}/call/Urmyaaccounteditcallqueuedetails`,
  Urmyaccountgetcallqvoicemailrecordings: `${config().API_SERVICE_URL}/call/Urmyaccountgetcallqvoicemailrecordings`,
  Urmyaccountgetcallqueuerecordings: `${config().API_SERVICE_URL}/call/Urmyaccountgetcallqueuerecordings`,
  Urmyaccountcallqueuegetcustomhour: `${config().API_SERVICE_URL}/call/Urmyaccountcallqueuegetcustomhour`,
  Urmyaccountgetcallqueuecalllogs: `${config().API_SERVICE_URL}/call/Urmyaccountgetcallqueuecalllogs`,
  Urmyaccountgetcallqueueperformance: `${config().API_SERVICE_URL}/call/Urmyaccountgetcallqueueperformance`,
  callQueueBulkEnableDelete: `${config().API_SERVICE_URL}/call/callQueueBulkEnableDelete`,


  // voicemail_search: `${config().NFSCDRURL}/voicemail/search`,




  PasswordValidation: `${config().API_SERVICE_URL}/login/password_validiation`,
  deleteCompanyInfoAdmin: `${config().apiCRMNodeURL}/company/deleteCompanyInfoAdmin`,

  marketing_updateUserDetails: `${config().MARKETING_SERVICE}/email/marketing_updateUserDetails `,
  marketing_deleteUserDetails: `${config().MARKETING_SERVICE}/email/marketing_deleteUserDetails `,
  user_default_workinghours :`${config().MARKETING_SERVICE}/booking/user_default_workinghours`,
  ab_forgot_password_reset :`${config().MARKETING_SERVICE}/booking/ab_forgot_password_reset`,



  CRM_create_sms_config_details:`${config().BOOKING_SERVICE}/CRM_create_sms_config_details`,
  ab_insert_update_notification_email_config_dtl:`${config().BOOKING_SERVICE}/ab_insert_update_notification_email_config_dtl`,

  //callblast
  Urcallblastgetdtl: `${config().API_SERVICE_URL}/call/Urcallblastgetdtl`,
  Urcallblastdeletedtl: `${config().API_SERVICE_URL}/call/Urcallblastdeletedtl`,
  Urcallblastgetfilename: `${config().API_SERVICE_URL}/call/Urcallblastgetfilename`,
  Urcallblastdtlsave: `${config().API_SERVICE_URL}/call/Urcallblastdtlsave`,
  Urgetcompanyextdtl: `${config().API_SERVICE_URL}/call/Urgetcompanyextdtl`,

  //translation
  updateTranslation: `${config().API_SERVICE_URL}/translation/updateTranslation`,
  updateVideoAudioSettings: `${config().API_SERVICE_URL}/transcription/updateVideoAudioSettings`,

  //transcrpt
  // updateTranscriptSettings: `${config().API_SERVICE_URL}/transcription/updateTranscriptSettings`,

  //
  Urmyaccountcreateupdatecccardinfo: `${config().API_SERVICE_URL}/transcription/Urmyaccountcreateupdatecccardinfo`,

  // Topup

  Urmyaccountautotopupenabledisable: `${config().API_SERVICE_URL}/topup/Urmyaccountautotopupenabledisable`,
  Urmyaccountdotopupcdconline: `${config().API_SERVICE_URL}/topup/Urmyaccountdotopupcdconline`,

  //user Panel

  Urmyaccwebgetuserpersonaldtl: `${config().API_SERVICE_URL}/userpanel/Urmyaccwebgetuserpersonaldtl`,
  Urmyaccgetcountrylistinfo: `${config().API_SERVICE_URL}/userpanel/Urmyaccgetcountrylistinfo`,
  Urmyaccwebsaveuserpersonaldtl: `${config().API_SERVICE_URL}/userpanel/Urmyaccwebsaveuserpersonaldtl`,
  Urmyaccwebgetgetcalleriddtl: `${config().API_SERVICE_URL}/numbers_devices/Urmyaccwebgetgetcalleriddtl`,
  Urmyaccgetconferencemasterinfo: `${config().API_SERVICE_URL}/userpanel/Urmyaccgetconferencemasterinfo`,
  Urmagetavailableconferencenumberdtl: `${config().API_SERVICE_URL}/userpanel/Urmagetavailableconferencenumberdtl`,
  Urusergetphoneinfo: `${config().API_SERVICE_URL}/userpanel/Urusergetphoneinfo`,
  Urextnphonenameupdate: `${config().API_SERVICE_URL}/userpanel/Urextnphonenameupdate`,
  Urmyaccwebgetupdatecalleridnumber: `${config().API_SERVICE_URL}/userpanel/Urmyaccwebgetupdatecalleridnumber`,
  Urmyaccwebgetcompanyregionalsettingdtl: `${config().API_SERVICE_URL}/userpanel/Urmyaccwebgetcompanyregionalsettingdtl`,
  Urdisplaypicture: `${config().API_SERVICE_URL}/userpanel/Urdisplaypicture`,

  //Call Handling (out of service)
  Urextnfindflowmesave: `${config().API_SERVICE_URL}/users/Urextnfindflowmesave`,
  Urextnfindflowmeupdate: `${config().API_SERVICE_URL}/users/Urextnfindflowmeupdate`,

  //security
  // create_policy_info: `https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/policy/create_policy_info`,
  create_policy_info: `${config().API_SERVICE_URL}/policy/create_policy_info`,
  get_policy_info: `${config().API_SERVICE_URL}/policy/get_policy_info`,
  get_policy_auth_ip_restrication: `${config().API_SERVICE_URL}/policy/get_policy_auth_ip_restrication`,
  update_policy_auth_restrication_info: `${config().API_SERVICE_URL}/policy/update_policy_auth_restrication_info`,
  get_policy_editable_fields_list: `${config().API_SERVICE_URL}/policy/get_policy_editable_fields_list`,
  get_policy_roles_info: `${config().API_SERVICE_URL}/policy/get_policy_roles_info`,
  update_policy_password_info: `${config().API_SERVICE_URL}/policy/update_policy_password_info`,
  // update_policy_password_info: `https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/policy/update_policy_password_info`,
  update_policy_role_info: `${config().API_SERVICE_URL}/policy/update_policy_role_info`,

  update_policy_session_info: `${config().API_SERVICE_URL}/policy/update_policy_session_info`,

  //tableviewapi`
  Urextnfindflowmeget: `${config().API_SERVICE_URL}/call/Urextnfindflowmeget`,

  //hubspot
  hubspot_update_batch_contact: `${config().API_SERVICE_URL}/users/hubspot_update_batch_contact`,
  hubspot_create_batch_contact: `${config().API_SERVICE_URL}/users/hubspot_create_batch_contact`,
  ecomPaymentStep1: `${config().ECOM_PAYMENT_URL}/step1`,
  ecomPaymentCheck3ds: `${config().ECOM_PAYMENT_URL}/check3ds`,
  updateMDReturnURl: `${config().ECOM_PAYMENT_URL}/updateMDReturnURl`,
  ecomPaymentCreateSubscribtion: `${config().ECOM_PAYMENT_URL}/urecomcreatesubscribtion`,
  updateAccountid: `${config().ECOM_PAYMENT_URL}/updateAccountid`,
  //ccaas
  ccaasup_InsertPlanRecharge: `${config().API_SERVICE_URL}/worktual/up_InsertPlanRecharge`,
  ccaasSetDefaultCompany: `${config().CCAAS_SERVICE_URL}/set_default_company`,
  ccaasInsertOnboardUser: `${config().CCAAS_SERVICE_URL}/insert_onboard_user`,
  ccaasInsertOnboardDidNumber: `${config().CCAAS_SERVICE_URL}/onboard_did_number`,
  ccaasUpdateOnboardUser: `${config().CCAAS_SERVICE_URL}/update_Onboard_user`,
  ccaasUserActiveStatus: `${config().CCAAS_SERVICE_URL}/update_onboard_user_active_status`,

  //otp 
  generateOtp : `https://did.worktual.co.uk/otp/v1/generate`,
  validateOtp : 'https://did.worktual.co.uk/otp/v1/validate',

  getUserId: `${config().CCAAS_SERVICE_URL}/getUserId`,
  updateEmailBotStatus: `${config().emailService}/onbord_update_email_bot_status`,
  carehomeonboardinsert: `${config().apiCcaasHomeCareURL}/create_onboard_user_company`,

  // updateSMSBotStatus: `${config().callServices}/onbord_update_sms_bot_status`,

  updateSMSBotStatus: `${config().smsServices}/update_sms_bot_status`,
  // custom_filelds
  createCustomFields: `${config().API_SERVICE_URL}/worktual/createcustomfield`,
  CustomFieldsList: `${config().API_SERVICE_URL}/worktual/getcustomfield`,
  DeleteCustomFields: `${config().API_SERVICE_URL}/worktual/deletecustomfield`,
  getcustomfieldtype: `${config().API_SERVICE_URL}/worktual/getcustomfieldtype`,
  getcustomfield: `${config().API_SERVICE_URL}/worktual/getcustomfield`,
  getUserFieldName: `${config().API_SERVICE_URL}/worktual/getuserfieldname`,
  updateField: `${config().API_SERVICE_URL}/worktual/update_custom_filed_is_mandatory`,

  //mapping
  uploadBulkUserMapping: `${config().API_SERVICE_URL}/worktual/upload_bulk_user_mapping`,
  //activity log
  ActivityLog: `${config().API_SERVICE_URL}/worktual/get_activity_log_details`,

  //Reports
  get_company_user_report: `${config().API_SERVICE_URL}/worktual/get_company_user_report`,
  get_company_user_activity_report: `${config().API_SERVICE_URL}/worktual/get_company_user_activity_report`,

  //ext update
  ExtensionUpdate: `${config().API_SERVICE_URL}/worktual/audio_file_extension_update`,
  //IVR LIST
  GetIvrDropList: `${config().API_SERVICE_URL}/worktual/get_ivr_route_to_list`,
  InsertIvrKey: `${config().API_SERVICE_URL}/worktual/insert_ivr_key_route_to_info`,
  Get_ivr_key_route_to_info: `${config().API_SERVICE_URL}/worktual/get_ivr_key_route_to_info`,
  GetIvrList: `${config().API_SERVICE_URL}/worktual/get_ivr_key_dtl`,

  //curr conv
  currencyConversion:`${config().API_SERVICE_URL}/worktual/get_currency_converter`,
  // config details

  getIvrList: `${config().apiReactURL}/get_ivr`,
  updateIvr: `${config().apiReactURL}/new_update`,


  //discount api

  validateCompanyDiscount: `${config().API_SERVICE_URL}/company/validateCompanyDiscount`,
  updateCompanyDiscountCode: `${config().API_SERVICE_URL}/company/updateCompanyDiscountCode`,

  //teams api
  refresh_token_graph: `${config().CCAAS_CONNECTOR_URL}/directrouting/graph/refresh_token`,
  refresh_token_teams: `${config().CCAAS_CONNECTOR_URL}/directrouting/teams/refresh_token`,
  store_Token: `${config().CCAAS_CONNECTOR_URL}/directrouting/storeToken`,
  user_list: `${config().CCAAS_CONNECTOR_URL}/directrouting/teams/users`,
  group_list: `${config().CCAAS_CONNECTOR_URL}/directrouting/teams/groups`,
  domain_Admin: `${config().CCAAS_CONNECTOR_URL}/directrouting/teams/admin/domain`,
  insertTeamsDirectRouting: `${config().API_SERVICE_URL}/worktual/insertTeamsDirectRouting`,
  teamsuserlistapi: `${config().API_SERVICE_URL}/worktual/ur_myacc_get_teams_direct_routing_meeting`,
  directRouting_sync:`${config().CCAAS_CONNECTOR_URL}/directrouting/teams/sync`,
  teams_fqdn_port:`${config().CCAAS_CONNECTOR_URL}/directrouting/fqdn/port`,
  insert_txt_record : `${config().CCAAS_CONNECTOR_URL}/directrouting/insertTxtFile`,
  get_particular_fqdn : `${config().CCAAS_CONNECTOR_URL}/directrouting/fqdnDetails`,
  deleteDirectRoutingConnection : `${config().CCAAS_CONNECTOR_URL}/directrouting/deleteRequest`,

  password_update:`https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/password_update`,
  add_user_invitation:`https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/add_user_invi`,
  add_user_invitation_ccaas:`https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/add_user_invi_ccass`,
  add_user_invitation_chatbot:`https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/add_user_invi_chatbot`,
  resend_onboard_mail:'https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/resend_link',
  admin_company_info:'https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/admin_company_info',
  topup_success:'https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/topup_payment_success',
  addon_success:'https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/addon_payment_success',
  forgot_password_link_send:`https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/forgot_password_req`,
  sme_get_partner_order_form:`https://mysqlapi.worktual.co.uk/urpartnerportal-mysql/v1/sme/sme_get_partner_order_form`,
  create_partner_order_form:`https://mysqlapi.worktual.co.uk/urpartnerportal-mysql/v1/sme/create_partner_order_form`,
  get_sales_team_extn_info:" https://mysqlapi.worktual.co.uk/urutms-mysql/v1/user//ur_get_sales_team_extn_info",

  
  // PAYMENT

  stripe_payment_v1:`${config().API_SERVICE_URL}/payment/payment_v1`,
  qastripe_payment_v1:`${config().API_SERVICE_URL}/payment/qapayment_v1`,

  
  //renewalAccount
  UrrenewalAccount: `${config().API_SERVICE_URL}/payment/renewpayment`,


  

  sitecode: `UFUK`,
  appcode: `UFGBP`,
  productcode: `UFUK`,
  paymentagent: `UFUK`,
  servicetype: `RES`,
  paymentmode: `DEF`,
  site_currency: `GBP`,
  payment_country: `United Kingdom,UK`,
};
